const getQueryParameter = name => {
  const value = String(String(document.location.search).split(`${name}=`)[1]).split('&')[0];

  return decodeURIComponent(value);
};

const load = () => {
  const targetClassName = 'js-paddle';

  const el = document.querySelector(`[data-type="checkout"]`);

  if (!el) {
    return;
  }

  ['href', 'text', 'src', 'alt'].forEach(attribute => {
    el.querySelectorAll(`[data-${attribute}]`).forEach(node => {
      const value = getQueryParameter(node.dataset[attribute]);
      if (value) {
        node[attribute === 'text' ? 'innerText' : attribute] = value;
      }
    });
  });

  const script = document.createElement('script');
  script.id = 'paddle';
  script.src = 'https://cdn.paddle.com/paddle/paddle.js';
  script.onload = () => {
    const Paddle = window.Paddle;

    Paddle.Setup({
      vendor: getQueryParameter('paddlevendor') || '102262',
    });

    Paddle.Checkout.open({
      method: 'inline',
      product: getQueryParameter('paddleproductid') || '592328', // Replace with your Product or Plan ID
      allowQuantity: false,
      disableLogout: true,
      frameTarget: targetClassName, // The className of your checkout <div>
      frameStyle: 'background-color: transparent; width: 360px; border: none;',
      loadCallback: () => {
        document.querySelector(`.${targetClassName}`).style.visibility = 'unset';
      },
    });
  };

  document.head.appendChild(script);
};

const main = () => {
  load();
};

main();
